import { produce } from 'immer'
import { State } from '../../typings'
import { GridSortModel } from '@mui/x-data-grid-pro'
import { ActivitySummaryHelpers } from '../../../helpers'

export const setActivitySummaryOrderByProducer = produce<
  State,
  [GridSortModel | undefined]
>((draft, payload = []) => {
  const newOrderBy = ActivitySummaryHelpers.getOrderBy(payload)
  const prevOrderBy = draft.filterSet.orderBy

  if (newOrderBy === prevOrderBy) {
    return
  }

  draft.filterSet.orderBy = newOrderBy
  draft.tableState.paginationState.page = 0
})
